import { stringify } from 'qs';

import { TThunkDispatch, IApplicationState } from '../../types/redux';
import { META_TITLE } from '../../constants/meta';

export function updateQueryString() {
  return (dispatch: TThunkDispatch, getState: () => IApplicationState) => {
    const { filters } = getState();
    const { protocol, host, pathname } = window.location;

    const queryString = stringify(filters);

    const url = `${protocol}//${host}${pathname}?${queryString}`;

    window.history.pushState('', META_TITLE, url);
  };
}
